<template>
    <a-modal width="65%" title="查看" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @cancel="onClose" :footer="null" wrap-class-name="single-spa-vue">

        <a-descriptions :column="1" bordered>

            <a-descriptions-item label="专利名称">{{ form.patentName }}</a-descriptions-item>
            <a-descriptions-item label="说明摘要">
                <span v-html="form.description"></span>
            </a-descriptions-item>
            <a-descriptions-item label="专利类别">
                <dict-render :dict-obj="dictObjs['projectType']" :text="form.patentCategory"
                             v-if="form.patentCategory"></dict-render>
            </a-descriptions-item>

            <a-descriptions-item label="专利号">{{form.patentNumber}}</a-descriptions-item>

            <a-descriptions-item label="专利有效期始">{{form.validityStart}}</a-descriptions-item>
            <a-descriptions-item label="专利有效期末">{{form.validityEnd}}</a-descriptions-item>
            <a-descriptions-item label="授权时间">{{form.authorizationDate}}</a-descriptions-item>
            <a-descriptions-item label="授权方式">
                <dict-render :dict-obj="dictObjs['intellectualsubsidy_get']" :text="form.accredit"></dict-render>
            </a-descriptions-item>

            <a-descriptions-item label="审核状态">
                <dict-render :dict-obj="dictObjs['aduit_status']" :text="form.auditStatus"
                             v-if="form.auditStatus"></dict-render>
            </a-descriptions-item>


        </a-descriptions>
    </a-modal>
</template>

<script>
    import {formMixin, dictMixin} from "@/mixins";
    import DictRender from "@/components/other/DictRender";

    export default {
        name: "Detail",
        mixins: [formMixin, dictMixin],
        components: {DictRender},
        data() {
            return {
                dictNames: "demand_type,aduit_status,projectType,intellectualsubsidy_get",
                form: {
                    id: null,
                    brandName: null,
                    scopeApplication: null,
                    brandIndustryType: null,
                    rangeAnalysis: null,
                    validityStart: null,
                    validityEnd: null,
                    authorizationDate: null,
                    accredit: null,
                    auditTime: null,
                    abutmentPhone: null,
                    abutmentUserName: null,
                    abutmentStartTime: null,
                    abutmentEndTime: null,
                    serviceStatus: null,
                    isOpen: null,
                },
            }
        },
        methods: {
            onClose() {
                this.visible = false
                this.$emit("onCloseModel")
            },
        }
    }
</script>

<style scoped lang="less">

</style>
